import { Action, ActionKind, IState } from './actions';

export const initialState: IState = {
  id: '',
  operation: 'none',
  isProcessing: false,
};

export const fermentationActionReducer = (state: IState, action: Action): IState => {
  switch (action.type) {
    case ActionKind.OpenFermentationRemoveModal:
      return { isProcessing: true, operation: 'remove', id: action.id };
    case ActionKind.OpenFermentationCompleteModal:
      return { isProcessing: true, operation: 'complete', id: action.id };
    case ActionKind.OpenAddBatchIntoFermentationModal:
      return { isProcessing: true, operation: 'add', id: action.id };
    case ActionKind.ResetFermentationOperation:
      return { ...state, operation: 'none' };
    case ActionKind.ResetFermentationActionState:
      return { ...initialState };
    default:
      return state;
  }
};
